<div
  class="min-h-screen min-w-[100vw] flex items-center justify-center bg-primary-100"
>
    <div class="container">
      <div class="card w-full">
        <h2 class="mt-4">😓 Parece que tenemos un problema...</h2>
        <p>
            No tenemos registro de la referencia a la que estás tratando de acceder. Por favor dirígete a tu centro Luxoro más cercano para recibir ayuda
        </p>
        <div class="mt-8">
            <p-button label="Volver al inicio" (onClick)="goToLuxoro()"></p-button>
        </div>
      </div>
    </div>
</div>
